import {
  DeleteWithConfirmButton,
  useRecordContext,
  useTranslate,
  useNotify,
} from "react-admin";
import DeleteIcon from "@mui/icons-material/Delete";

const DeleteButton = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const t = useTranslate();

  if (!record) return null;

  return (
    <DeleteWithConfirmButton
      label="buttons.delete"
      confirmContent="resources.notifications.confirm.delete"
      confirmTitle={`${t("buttons.delete")} #${
        record.name || record.title || record.id
      }`}
      confirmColor="warning"
      icon={<DeleteIcon fontSize="small" sx={{ color: "#d10000" }} />}
      translateOptions={{ name: record.name || record.title }}
      mutationOptions={{
        onError: ({ message }) => {
          console.log("HERE");
          return notify(`resources.notifications.errors.${message}`, {
            type: "error",
            autoHideDuration: 2000,
          });
        },
      }}
    />
  );
};

export default DeleteButton;
